<template>
  <v-row class="pt-5" v-if="items">

    <v-col cols="10" offset="1" v-for="item in items" :key="item.id">
      
      <h2 class="title">{{getUser(item.uid)}}</h2>
      <travel-results :uid="item.uid" :pid="item.pid"></travel-results>

    </v-col>
  </v-row>
</template>

<script>
// import lodash from "lodash";

import {
  TravelResults
} from "@/views/user/exercises/travel";

const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";

export default {
  name: "ResultsPropositionUser",
  data() {
    return {
      items: null,
      admins: null,
      users: null
    };
  },
  props: {
    uid: String,
    id: String
  },
  watch: {
    uid(val) {
      if (val) {
        this.getExercise();
      }
    },
  },
  components: {
    TravelResults
  },
  mounted() {
    this.getAdmins();
    this.getUsers();
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
  },
  methods: {
    getAdmins() {
      let ref = fb.profilesCollection.where("webrole","==","admin");
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post.uid);
          });
          if (items) {
            this.admins = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getUsers() {
      let ref = fb.profilesCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            this.users = items;
          }
          this.getExercise();
        })
        .catch(function() {});
    },
    getUser(id) {
      let item = this.users.find(item => item.uid === id)
      return this.users ? `${item.first} ${item.last}` : ''
    },
    getExercise() {
      this.doc = null;
      let ref = fb.travelExCollection
        .where("pid", "==", this.id)
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            // if (!this.admins.some(x => x == post.uid)) {
            //   items.push(post);
            // }
             items.push(post);
          });
          if (items) {
            this.items = items;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
